import { Box as MuiBox, BoxProps } from '@mui/material'
import { styled } from '@mui/system'

interface MuiBoxProps extends BoxProps {
  appwidth: string
}

export const ContainerBox = styled(MuiBox)<MuiBoxProps>(({ appwidth }) => ({
  // maxHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  position: 'relative',
  width: appwidth,
}))

export const ContentBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  // maxHeight: '100vh',
  bgcolor: theme.palette.background.default,
}))
